// import React, { useState, useEffect } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import {
//   Box,
//   Container,
//   Typography,
//   Grid,
//   Card,
//   CardMedia,
//   CardContent,
//   Button,
//   IconButton,
//   useTheme,
//   Paper,
// } from "@mui/material";
// import {
//   ArrowForward,
//   PlayArrow,
//   Explore,
//   School,
//   Star,
// } from "@mui/icons-material";
// import axios from "axios";
// import { motion, AnimatePresence } from "framer-motion";

// // Components
// import Header from "../Components/Header";
// import StudentSidebar from "./StudentSdebar";

// // Images
// import Slider1 from "../Images/SliderImage2.jpg";
// import Slider2 from "../Images/SliderImage3.jpg";
// import DummyCourse from "../Images/DummyCourseImage.jpg";

// const Home = () => {
//   const navigate = useNavigate();
//   const theme = useTheme();
//   const [popularCourses, setPopularCourses] = useState([]);
//   const [currentSlide, setCurrentSlide] = useState(0);
//   const [sidebarExpanded, setSidebarExpanded] = useState(true);

//   const API_URL = "https://tdtlworld.com/dss-kaas-backend/";

//   const slides = [
//     {
//       image: Slider1,
//       title: "Master New Skills",
//       subtitle: "Expert-led courses designed for your career growth.",
//     },
//     {
//       image: Slider2,
//       title: "Learn Anywhere",
//       subtitle: "Flexible learning that fits into your busy schedule.",
//     },
//   ];

//   useEffect(() => {
//     axios.get(`${API_URL}lms/popular/`).then((response) => {
//       setPopularCourses(response.data.popular_courses || []);
//     });

//     const timer = setInterval(() => {
//       setCurrentSlide((prev) => (prev + 1) % slides.length);
//     }, 5000);
//     return () => clearInterval(timer);
//   }, []);

//   return (
//     <Box
//       sx={{
//         display: "flex",
//         flexDirection: "column",
//         minHeight: "100vh",
//         bgcolor: "background.default",
//       }}
//     >
//       <Header />

//       <Box sx={{ display: "flex", flexGrow: 1 }}>
//         <StudentSidebar onToggle={setSidebarExpanded} />

//         <Box
//           component="main"
//           sx={{
//             flexGrow: 1,
//             p: { xs: 2, md: 4 },
//             width: sidebarExpanded ? "calc(100% - 260px)" : "calc(100% - 80px)",
//             transition: theme.transitions.create("width", { duration: 300 }),
//           }}
//         >
//           {/* Hero Slider */}
//           <Box
//             sx={{
//               position: "relative",
//               height: { xs: "300px", md: "500px" },
//               mb: 6,
//               borderRadius: "24px",
//               overflow: "hidden",
//             }}
//           >
//             <AnimatePresence mode="wait">
//               <motion.div
//                 key={currentSlide}
//                 initial={{ opacity: 0 }}
//                 animate={{ opacity: 1 }}
//                 exit={{ opacity: 0 }}
//                 transition={{ duration: 1 }}
//                 style={{
//                   position: "absolute",
//                   width: "100%",
//                   height: "100%",
//                   backgroundImage: `linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url(${slides[currentSlide].image})`,
//                   backgroundSize: "cover",
//                   backgroundPosition: "center",
//                   display: "flex",
//                   alignItems: "center",
//                   padding: "0 10%",
//                 }}
//               >
//                 <Box sx={{ color: "white", maxWidth: "600px" }}>
//                   <motion.div
//                     initial={{ y: 30, opacity: 0 }}
//                     animate={{ y: 0, opacity: 1 }}
//                     transition={{ delay: 0.5 }}
//                   >
//                     <Typography variant="h2" fontWeight={800} gutterBottom>
//                       {slides[currentSlide].title}
//                     </Typography>
//                     <Typography variant="h5" sx={{ mb: 4, opacity: 0.9 }}>
//                       {slides[currentSlide].subtitle}
//                     </Typography>
//                     <Button
//                       variant="contained"
//                       size="large"
//                       startIcon={<PlayArrow />}
//                       onClick={() => navigate("/db-shiksha/kaas/student/coursePage")}
//                       sx={{ borderRadius: "50px", px: 4 }}
//                     >
//                       Start Learning
//                     </Button>
//                   </motion.div>
//                 </Box>
//               </motion.div>
//             </AnimatePresence>
//           </Box>

//           {/* Featured Courses */}
//           <Box sx={{ mb: 6 }}>
//             <Box
//               sx={{
//                 display: "flex",
//                 justifyContent: "space-between",
//                 alignItems: "center",
//                 mb: 4,
//               }}
//             >
//               <Typography variant="h4" fontWeight={800} color="#D4AF37">
//                 Popular Courses
//               </Typography>
//               <Button
//                 component={Link}
//                 to="/db-shiksha/kaas/student/coursePage"
//                 endIcon={<ArrowForward />}
//               >
//                 View All
//               </Button>
//             </Box>

//             <Grid container spacing={3}>
//               {(popularCourses.length > 0
//                 ? popularCourses.slice(0, 3)
//                 : [1, 2, 3]
//               ).map((course, i) => (
//                 <Grid item xs={12} sm={6} md={4} key={i}>
//                   <Card
//                     sx={{
//                       height: "100%",
//                       display: "flex",
//                       flexDirection: "column",
//                       transition: "transform 0.3s ease",
//                       "&:hover": {
//                         transform: "translateY(-10px)",
//                         borderColor: "#D4AF37",
//                       },
//                     }}
//                   >
//                     <CardMedia
//                       component="img"
//                       height="200"
//                       image={course.cover_img || DummyCourse}
//                       alt={course.title}
//                     />
//                     <CardContent sx={{ flexGrow: 1 }}>
//                       <Typography
//                         variant="h6"
//                         fontWeight={700}
//                         gutterBottom
//                         noWrap
//                       >
//                         {course.title || "Loading Course..."}
//                       </Typography>
//                       <Typography
//                         variant="body2"
//                         color="text.secondary"
//                         sx={{ mb: 2, height: "40px", overflow: "hidden" }}
//                       >
//                         {course.description ||
//                           "Expert-led training in cutting-edge technologies."}
//                       </Typography>
//                       <Box
//                         sx={{
//                           display: "flex",
//                           justifyContent: "space-between",
//                           alignItems: "center",
//                         }}
//                       >
//                         <Typography
//                           variant="h6"
//                           fontWeight={800}
//                           color="#D4AF37"
//                         >
//                           {course.price ? `₹${course.price}` : "Free"}
//                         </Typography>
//                         <Button
//                           variant="outlined"
//                           size="small"
//                           onClick={() =>
//                             navigate(
//                               `/db-shiksha/kaas/student/course/${course.course_id}`,
//                             )
//                           }
//                           sx={{ borderRadius: "50px" }}
//                         >
//                           Explore
//                         </Button>
//                       </Box>
//                     </CardContent>
//                   </Card>
//                 </Grid>
//               ))}
//             </Grid>
//           </Box>

//           {/* Stats Bar */}
//           <Paper
//             sx={{
//               p: 4,
//               borderRadius: "24px",
//               background: theme.palette.mode === "dark" ? "#1A1A1A" : "#FFFFFF",
//               color: "white",
//             }}
//           >
//             <Grid
//               container
//               spacing={4}
//               textAlign="center"
//               color={theme.palette.mode === "dark" ? "#FFFFFF" : "#000000"}
//             >
//               {[
//                 {
//                   label: "Active Students",
//                   val: "5000+",
//                   icon: <School sx={{ color: "#D4AF37" }} />,
//                 },
//                 {
//                   label: "Expert Courses",
//                   val: "200+",
//                   icon: <Explore sx={{ color: "#D4AF37" }} />,
//                 },
//                 {
//                   label: "Average Rating",
//                   val: "4.8/5",
//                   icon: <Star sx={{ color: "#D4AF37" }} />,
//                 },
//               ].map((stat, i) => (
//                 <Grid item xs={12} md={4} key={i}>
//                   <Box
//                     sx={{
//                       display: "flex",
//                       flexDirection: "column",
//                       alignItems: "center",
//                     }}
//                   >
//                     {stat.icon}
//                     <Typography variant="h4" fontWeight={800} sx={{ mt: 1 }}>
//                       {stat.val}
//                     </Typography>
//                     <Typography variant="subtitle2" sx={{ opacity: 0.7 }}>
//                       {stat.label}
//                     </Typography>
//                   </Box>
//                 </Grid>
//               ))}
//             </Grid>
//           </Paper>
//         </Box>
//       </Box>
//     </Box>
//   );
// };

// export default Home;
import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  Box,
  Container,
  Typography,
  Grid,
  Card,
  CardMedia,
  CardContent,
  Button,
  IconButton,
  useTheme,
  Paper,
} from "@mui/material";
import {
  ArrowForward,
  PlayArrow,
  Explore,
  School,
  Star,
} from "@mui/icons-material";
import axios from "axios";
import { motion, AnimatePresence } from "framer-motion";

// Components
import Header from "../Components/Header";
import StudentSidebar from "./StudentSdebar";

// Images
import Slider1 from "../Images/SliderImage2.jpg";
import Slider2 from "../Images/SliderImage3.jpg";
import DummyCourse from "../Images/DummyCourseImage.jpg";

const Home = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const [popularCourses, setPopularCourses] = useState([]);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [sidebarExpanded, setSidebarExpanded] = useState(true);

  const API_URL = "https://tdtlworld.com/dss-kaas-backend/";

  const slides = [
    {
      image: Slider1,
      title: "Master New Skills",
      subtitle: "Expert-led courses designed for your career growth.",
    },
    {
      image: Slider2,
      title: "Learn Anywhere",
      subtitle: "Flexible learning that fits into your busy schedule.",
    },
  ];

  useEffect(() => {
    axios.get(`${API_URL}lms/popular/`).then((response) => {
      setPopularCourses(response.data.popular_courses || []);
    });

    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100vh",
        overflow: "hidden",
        bgcolor: "background.default",
      }}
    >
      <Header />

      <Box sx={{ display: "flex", flexGrow: 1, overflow: "hidden" }}>
        <StudentSidebar onToggle={setSidebarExpanded} />

        <Box
          component="main"
          sx={{
            flexGrow: 1,
            p: { xs: 2, md: 4 },
            width: sidebarExpanded ? "calc(100% - 260px)" : "calc(100% - 80px)",
            transition: theme.transitions.create("width", { duration: 300 }),
            height: "calc(100vh - 64px)",
            overflowY: "auto",
          }}
        >
          {/* Hero Slider */}
          <Box
            sx={{
              position: "relative",
              height: { xs: "300px", md: "500px" },
              mb: 6,
              borderRadius: "24px",
              overflow: "hidden",
            }}
          >
            <AnimatePresence mode="wait">
              <motion.div
                key={currentSlide}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 1 }}
                style={{
                  position: "absolute",
                  width: "100%",
                  height: "100%",
                  backgroundImage: `linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url(${slides[currentSlide].image})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  display: "flex",
                  alignItems: "flex-end",
                  padding: "0 10% 5%",
                }}
              >
                <Box sx={{ color: "white", maxWidth: "600px" }}>
                  <motion.div
                    initial={{ y: 30, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    transition={{ delay: 0.5 }}
                  >
                    <Typography variant="h2" fontWeight={800} gutterBottom>
                      {slides[currentSlide].title}
                    </Typography>
                    <Typography variant="h5" sx={{ mb: 4, opacity: 0.9 }}>
                      {slides[currentSlide].subtitle}
                    </Typography>
                    <Button
                      variant="contained"
                      size="large"
                      startIcon={<PlayArrow />}
                      onClick={() =>
                        navigate("/db-shiksha/kaas/student/coursePage")
                      }
                      sx={{ borderRadius: "50px", px: 4 }}
                    >
                      Start Learning
                    </Button>
                  </motion.div>
                </Box>
              </motion.div>
            </AnimatePresence>
          </Box>

          {/* Featured Courses */}
          <Box sx={{ mb: 6 }}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 4,
              }}
            >
              <Typography
                variant="h4"
                fontWeight={800}
                sx={{
                  color: theme.palette.mode === "dark" ? "white" : "black",
                }}
              >
                Popular Courses
              </Typography>
              <Button
                component={Link}
                to="/db-shiksha/kaas/student/coursePage"
                endIcon={<ArrowForward />}
              >
                View All
              </Button>
            </Box>

            <Grid container spacing={3}>
              {(popularCourses.length > 0
                ? popularCourses.slice(0, 3)
                : [1, 2, 3]
              ).map((course, i) => (
                <Grid item xs={12} sm={6} md={4} key={i}>
                  <Card
                    sx={{
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                      transition: "transform 0.3s ease",
                      "&:hover": {
                        transform: "translateY(-10px)",
                        borderColor: "#D4AF37",
                      },
                    }}
                  >
                    <CardMedia
                      component="img"
                      height="200"
                      image={course.cover_img || DummyCourse}
                      alt={course.title}
                    />
                    <CardContent sx={{ flexGrow: 1 }}>
                      <Typography
                        variant="h6"
                        fontWeight={700}
                        gutterBottom
                        noWrap
                      >
                        {course.title || "Loading Course..."}
                      </Typography>
                      <Typography
                        variant="body2"
                        color="text.secondary"
                        sx={{ mb: 2, height: "40px", overflow: "hidden" }}
                      >
                        {course.description ||
                          "Expert-led training in cutting-edge technologies."}
                      </Typography>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <Typography
                          variant="h6"
                          fontWeight={800}
                          color="#D4AF37"
                        >
                          {course.price ? `₹${course.price}` : "Free"}
                        </Typography>
                        <Button
                          variant="outlined"
                          size="small"
                          onClick={() =>
                            navigate(
                              `/db-shiksha/kaas/student/course/${course.course_id}`,
                            )
                          }
                          sx={{ borderRadius: "50px" }}
                        >
                          Explore
                        </Button>
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </Box>

          {/* Stats Bar */}
          <Paper
            sx={{
              p: 4,
              borderRadius: "24px",
              color: "white",
            }}
          >
            <Grid container spacing={4} textAlign="center">
              {[
                {
                  label: "Active Students",
                  val: "5000+",
                  icon: <School sx={{ color: "#D4AF37" }} />,
                },
                {
                  label: "Expert Courses",
                  val: "200+",
                  icon: <Explore sx={{ color: "#D4AF37" }} />,
                },
                {
                  label: "Average Rating",
                  val: "4.8/5",
                  icon: <Star sx={{ color: "#D4AF37" }} />,
                },
              ].map((stat, i) => (
                <Grid item xs={12} md={4} key={i}>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      color: theme.palette.mode === "dark" ? "white" : "black",
                      backgroundColor:
                        theme.palette.mode === "dark" ? "#1A1A1A" : "#FFFFFF",
                    }}
                  >
                    {stat.icon}
                    <Typography variant="h4" fontWeight={800} sx={{ mt: 1 }}>
                      {stat.val}
                    </Typography>
                    <Typography variant="subtitle2" sx={{ opacity: 0.7 }}>
                      {stat.label}
                    </Typography>
                  </Box>
                </Grid>
              ))}
            </Grid>
          </Paper>
        </Box>
      </Box>
    </Box>
  );
};

export default Home;
